
webpack.register(
    'layouts/pages/topic/topic',
    function() {
        return import('layouts/pages/topic/topic');
    },
    true
);